let FAQsLoaded = false;

$(function () {
    $('#FAQs').click(function () {
        const faqModal = document.getElementById('FAQModal');
        if (faqModal) {
            bootstrap.Modal.getOrCreateInstance(faqModal).show();
        }
        if (!FAQsLoaded) setFAQModal();
    });
    $('#FAQModal').on('hidden.bs.modal', function () {
        $('#FAQs').focus();
    });
    $('#FAQViewClassesUpdate').click(async function () {
       let data = [];

       $('#FAQEditList .luis-class.blue').each(function () {
           data.push(parseInt($(this).attr('data-class')));
       });

       const client = new window.Luis.Api.Client();
        const result = await window.Luis.Api.processApiRequestWithStatus(() =>
            client.fAQViewClasses($('#FAQModal').attr('data-faqview'), data), document.getElementById('error-summary'));

       if (result && result.ok) {
           setFAQModal();
       }
    });
    $('#FAQEditList').on('click', '.luis-class',function () {
        if ($(this).hasClass('grey')) {
            $(this).removeClass('grey').addClass('blue');
        }
        else {
            $(this).removeClass('blue').addClass('grey');
        }
    });
    $('#FAQEdit').click(function () {
        $('#FAQEditBlock').toggle();
    });
});

async function setFAQModal() {
    const client = new window.Luis.Api.Client();
    const result = await window.Luis.Api.processApiRequest(() => client.fAQs($('#FAQModal').attr('data-faqview')), document.getElementById('error-summary'));

    if (result) {
        $('#FAQModalWait').hide();
        $('#FAQModalList').html('');

        if (result.faqs) {
            for (let i = 0; i < result.faqs.length; i++) {
                let html = $('#FAQTemplate').html();
                html = html.replace(/#ID#/g, result.faqs[i].fAQ_Id);
                html = html.replace(/#Question#/g, result.faqs[i].question);
                html = html.replace(/#Answer#/g, result.faqs[i].answer);
                $('#FAQModalList').append(html);
            }
        }

        $('#FAQEditList').html('');
        if (result.classes) {
            for (let i = 0; i < result.classes.length; i++) {
                let html = $('#FAQEditTemplate').html();
                html = html.replace(/#ID#/g, result.classes[i].class_Id);
                html = html.replace(/#Name#/g, result.classes[i].class_Name);
                $('#FAQEditList').append(html);
            }
        }

        if (result.viewClasses) {
            for (let i = 0; i < result.viewClasses.length; i++) {
                $('#FAQEditList .luis-class[data-class="' + result.viewClasses[i] + '"]').removeClass('grey').addClass('blue');
            }
        }
        
        FAQsLoaded = true;
        $('#FAQModalList').show();
    } else {
        $('#FAQModalWait').hide();
        $('#FAQModalNone').show();
    }
}

